<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONTRATOS - Relação de Notas Fiscais</span>
                </h4>
                <filtros
                    :responsaveis="responsaveis"
                    :unidades="unidades"
                    :fornecedores="fornecedores"
                    tiposFiltros="pdcm"
                    @filtroAtualizado="filtro = $event"
                ></filtros>
            </b-card-body>
            <b-card-footer>
                <app-btn-voltar></app-btn-voltar>
                <b-button
                    variant="primary"
                    @click.stop="emitirRelatorio()"
                    class="ml-2"
                >
                    <span>
                        <i class="fa fa-file-o mr-2"></i> Emitir Relatório</span
                    >
                </b-button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import Filtros from './Filtros'
import RelatoriosServicos from './RelatoriosServicos'

export default {
    components: {
        Filtros
    },

    data() {
        return {
            responsaveis: null,
            unidades: null,
            fornecedores: null,
            filtro: {
                contrato: null,
                responsavel: null,
                unidade: null,
                fornecedor: null,
                dataMovimentoDe: null,
                dataMovimentoAte: null
            }
        }
    },

    methods: {
        obterFiltrosOpcoes() {
            this.$store.dispatch('addRequest')
            RelatoriosServicos.obterFiltrosOpcoes('ruf').then((response) => {
                if (response) {
                    if (response.success) {
                        this.responsaveis = response.data.Funcionarios
                        this.responsaveis.unshift({
                            codFuncionario: null,
                            nome: 'TODOS'
                        })
                        this.unidades = response.data.Unidades
                        this.unidades.unshift({
                            codUnidade: null,
                            nome: 'TODAS'
                        })
                        this.fornecedores = response.data.Fornecedores
                        this.fornecedores.unshift({
                            codFornecedor: null,
                            nome: 'TODOS'
                        })
                    } else {
                        this.$toast.error(
                            'Erro ao obter opções do filtro!',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        emitirRelatorio() {
            this.$store.dispatch('addRequest')
            RelatoriosServicos.emitirRelatorio(
                'relacaonotasfiscais',
                this.filtro
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, 'RelacaoNotasFiscais.xlsx')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    mounted() {
        this.obterFiltrosOpcoes()
    },

    watch: {
        filtro() {}
    }
}
</script>
